module.exports = __webpack_public_path__ + "static/video-6fed3944757aa1b8411c74491dcbe840.mp4";